module.exports = __webpack_public_path__ + "img/mini_code.59242193.jpg";